import {
  GET_VEHICLE_STATUSES, GET_SUMMARY_TRIP, GET_RAW_ALERTS
} from '@/services/api/fleet'

import { client } from '@/services/apolloclient'

import moment from 'moment'
moment.locale('id')

export const state = {
  fleets: [],
  vehicleId: [],
  Notification: [],
  lastDataHistory: {},
  dataHistory: {
    licensePlate: null,
    imei: null,
    vehicleId: null,
    driver: null,
    direction: null,
    calculatedMotionStatus: null,
    tripstartOn: null,
    lastPacket: null,
    latitude: null,
    longitude: null,
    totalHourStop: null,
  },
  loadingKendaraan: false,
  loadingHistory: false,
  autoReload: true,
  fleetTrafficControl: true,
  fleetCluster: true,
  markerAll: true,
  markerPlate: true,
  markerHull: true,
  markerGps: true,
  markerLabel: true,
  markerLabelLayout: true,
  geoStatus: true,
  geoCluster: true,
  mapMode: "roadmap",
  speedChartStatus: false,
  speedChart: {
    category: [],
    data: []
  }
}

export const getters = {
  fleetsListFilter: (state) => search => {
    if (!search) {
      return state.fleets || []
    }

    return state.fleets.filter(fleet =>
      fleet.licensePlate.toLowerCase().match(search.toLowerCase()) ||
      (fleet.vehicle.driver1 ? fleet.vehicle.driver1.fullname.toLowerCase().match(search.toLowerCase()) : null)
    )
  },
  fleetsList: (state) => state.fleets || [],

  notificationsListFilter: (state) => search => {
    if (!search) {
      return state.Notification || []
    }

    return state.Notification.filter(notif =>
      notif.vehicle.licensePlate.toLowerCase().match(search.toLowerCase()) ||
      (notif.driver != null ? notif.driver.fullname.toLowerCase().match(search.toLowerCase()) : null)
    )
  },
  notificationsList: (state) => state.Notification || [],

  geoList: (state) => state.Geofence || [],
  geoListFilter: (state) => search => {
    if (!search) {
      return state.Geofence || []
    }
    return state.Geofence.filter(fleet => fleet.name_geo.toLowerCase().match(search.toLowerCase()))
  },

  lastHistoryList: (state) => state.lastDataHistory || {}
}

export const actions = {
  setHistory({ commit }, payload) {
    commit('SET_HISTORY', payload)
  },

  async requestFleets({ commit, dispatch }, payload) {
    await client.query({
      query: GET_VEHICLE_STATUSES,
      variables: payload.filter,
      fetchPolicy: 'no-cache',
    }).then((response) => {
      if (response.data.vehicleStatuses.isSuccessful) {

        var vehicles = response.data.vehicleStatuses.vehicleStatuses

        if (payload.plate != '') {
          const fleet = vehicles.filter(
            (fleet) =>
              fleet.licensePlate == payload.plate
          );

          if (payload.latLng.lat != fleet[0]["latitude"] && payload.latLng.lng != fleet[0]["longitude"]) {
            const data = {
              zoom: 15,
              open: true,
              gmp: fleet[0],
              type: "fleet",
            };

            dispatch('map/requestAddress', {
              lat: fleet[0]["latitude"],
              lng: fleet[0]["longitude"],
            }, { root: true })

            dispatch('map/setCENTER', data, { root: true })
          }
        }

        commit('setFleets', vehicles)
      }
    })
  },

  async requestNotifications({ state, commit }) {
    const date = {
      startDate: moment(`${moment().format('YYYY-MM-DD')} 00:00:00`).toISOString(),
      endDate: moment(`${moment().format('YYYY-MM-DD')} 23:59:59`).toISOString()
    }

    // const date = {
    //   startDate: moment(`${moment().format('YYYY-MM-DD')} 00:00:00`).toISOString(),
    //   endDate: moment(`${moment().format('YYYY-MM-DD')} 23:59:59`).toISOString()
    // }

    await client.query({
      query: GET_RAW_ALERTS,
      variables: {
        filter: {
          alertCode: [1, 11, 17, 18, 8, 23, 24, 3, 10, 12, 7, 16, 15, 51, 52, 53, 54, 55, 56],
          startDate: date.startDate,
          endDate: date.endDate,
          pagination: {
            page: 1,
            show: 50
          },
          orderBy: [JSON.stringify({ createdOn: 'desc' })],
          vehicleId: state.vehicleId
        }
      },
      fetchPolicy: 'no-cache',
    }).then((data) => {
      if (data.data.rawAlerts.isSuccessful) {
        let alerts = data.data.rawAlerts.rawAlerts.data
        commit('setNotifications', alerts)
      }
    })
  },

  async requestFleetHistory({ commit }, payload) {
    const response = await client.query({
      query: GET_SUMMARY_TRIP,
      fetchPolicy: 'no-cache',
      variables: {
        filter: payload
      }
    })

    if (response.data.summaryTrips.isSuccessful) {
      if (response.data.summaryTrips.summaryTrips.summaryTrips.length) {
        commit('setFleetHistory', response.data.summaryTrips.summaryTrips)
      } else {
        commit('setFleetHistory', [])
      }
    } else {
      commit('setFleetHistory', [])
    }
  }
}

export const mutations = {
  ORDER_BY(state, payload) {
    if (payload.type === 'date') {
      if (payload.order === 'asc') {
        state.fleets = state.fleets.sort(
          (a, b) => new Date(a[payload.objName]) - new Date(b[payload.objName])
        )
      } else {
        state.fleets = state.fleets.sort(
          (a, b) => new Date(b[payload.objName]) - new Date(a[payload.objName])
        )
      }
    } else {
      if (payload.order === 'asc') {
        state.fleets = state.fleets.sort((a, b) => (a[payload.objName] > b[payload.objName]) ? 1 : ((b[payload.objName] > a[payload.objName]) ? -1 : 0))
      } else {
        state.fleets = state.fleets.sort((a, b) => (b[payload.objName] > a[payload.objName]) ? 1 : ((a[payload.objName] > b[payload.objName]) ? -1 : 0))
      }
    }
  },

  SET_HISTORY(state, payload) {
    state.dataHistory.licensePlate = payload.licensePlate
    state.dataHistory.imei = payload.imei
    state.dataHistory.vehicleId = payload.vehicleId
    state.dataHistory.driver = payload.driver
    state.dataHistory.direction = payload.direction
    state.dataHistory.calculatedMotionStatus = payload.calculatedMotionStatus
    state.dataHistory.tripDrivetime = payload.tripDrivetime
    state.dataHistory.tripDistance = payload.tripDistance
    state.dataHistory.tripstartOn = payload.tripstartOn
    state.dataHistory.lastPacket = payload.lastPacket
    state.dataHistory.latitude = payload.latitude
    state.dataHistory.longitude = payload.longitude
  },

  RESET_HISTORY(state) {
    state.lastDataHistory = null,
      state.dataHistory = {
        licensePlate: null,
        imei: null,
        vehicleId: null,
        driver: null,
        direction: null,
        calculatedMotionStatus: null,
        tripstartOn: null,
        lastPacket: null
      }
  },

  SET_ADDRESS(state, payload) {
    state.Notification[payload.index].addressByMap = payload.address
  },

  setFleets(state, payload) {
    state.fleets = payload
  },

  setVehicleID(state, payload) {
    state.vehicleId = payload
  },

  setNotifications(state, payload) {
    state.Notification = payload
  },

  setFleetHistory(state, payload) {
    state.lastDataHistory = payload
  },

  sortFleetHistory(state) {
    state.lastDataHistory.reverse()
  },

  addTripDetail(state, payload) {
    state.lastDataHistory.summaryTrips[payload.index] = { ...state.lastDataHistory.summaryTrips[payload.index], details: payload.detail }
  },

  loadingKendaraan(state, payload) {
    state.loadingKendaraan = payload
  },

  loadingHistory(state, payload) {
    state.loadingHistory = payload
  },

  autoReload(state, payload) {
    state.autoReload = payload
  },

  fleetTrafficControl(state, payload) {
    state.fleetTrafficControl = payload
  },

  fleetCluster(state, payload) {
    state.fleetCluster = payload
  },

  geoStatus(state, payload) {
    state.geoStatus = payload
  },

  geoCluster(state, payload) {
    state.geoCluster = payload
  },

  speedChart(state, payload) {
    state.speedChart.category = payload.category
    state.speedChart.data = payload.data
  },

  speedChartStatus(state) {
    state.speedChartStatus = !state.speedChartStatus
  },

  markerAll(state, payload) {
    state.markerAll = payload
  },

  markerPlate(state, payload) {
    state.markerPlate = payload
  },

  markerHull(state, payload) {
    state.markerHull = payload
  },

  markerGps(state, payload) {
    state.markerGps = payload
  },

  markerLabel(state, payload) {
    state.markerLabel = payload
  },

  mapMode(state, payload) {
    state.mapMode = payload
  },

  markerLabelLayout(state, payload) {
    state.markerLabelLayout = payload
  }
}
